import { render, staticRenderFns } from "./RoleView.vue?vue&type=template&id=3fea0182&scoped=true&"
import script from "./RoleView.vue?vue&type=script&lang=js&"
export * from "./RoleView.vue?vue&type=script&lang=js&"
import style0 from "./RoleView.vue?vue&type=style&index=0&id=3fea0182&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fea0182",
  null
  
)

export default component.exports